import { getPlanErknmStatusByStatusTitle } from 'APIPackage/PlanListModule/common/getPlanErknmStatusByStatusTitle';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getPlanList = (state: IRootState) => state.planList;
export const getPlanListData = (state: IRootState) => getPlanList(state).data;
export const getPlanListTotalCount = (state: IRootState) => getPlanList(state).totalCount;
export const getPlanListStatuses = (state: IRootState) => getPlanList(state).statuses;
export const getPlanListPlan = (state: IRootState) => getPlanList(state).plan;
export const getPlanListPlanErknmStatusTitle = (state: IRootState) => getPlanList(state).plan?.erknmStatus;
export const getPlanListPlanErknmSigned = (state: IRootState) => getPlanList(state).plan?.signed;
export const getPlanListPlanErknmStatus = (state: IRootState) => {
  const planErknmStatusTitle = getPlanListPlanErknmStatusTitle(state);

  return getPlanErknmStatusByStatusTitle(planErknmStatusTitle);
};
export const getPlanListPlanStartDate = (state: IRootState) => getPlanList(state).plan?.startDate;
export const getPlanListApprovedForCurrentYear = (state: IRootState) => getPlanList(state).approvedPlansForCurrentYear;
export const getPlanSigned = (state: IRootState) => getPlanList(state)?.plan?.knmPlanData?.signedXlsxFile;
